import { ForwardedRef, forwardRef } from 'react';
import { LinkProps as MuiLinkProps } from '@mui/material/Link';
import { MuiLink } from '../../../../../modules/material';
import {
  useCustomizedSiteURL,
  UseCustomizedSiteURLProps,
} from '../../../hooks/useCustomizedSiteURL';

export interface LinkProps
  extends Omit<UseCustomizedSiteURLProps, 'url'>,
    MuiLinkProps {}

const Link = forwardRef(function Link(
  props: LinkProps,
  ref: ForwardedRef<HTMLAnchorElement>,
) {
  const {
    children,
    target,
    href,
    pathPrefix,
    query,
    disableSitePath,
    ...linkProps
  } = props;
  const rel = target === '_blank' ? 'noopener noreferrer' : '';

  const linkUrl = useCustomizedSiteURL({
    url: href,
    disableSitePath,
    pathPrefix,
    query,
  });

  return (
    <MuiLink {...linkProps} href={linkUrl} target={target} rel={rel} ref={ref}>
      {children}
    </MuiLink>
  );
});

export default Link;
